import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
  isDevMode,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { initializeDirectionFactory } from './services/initialize-direction.factory';
import { translateLoaderFactory } from './services/translate-loader-factory';
import { LanguageInterceptor } from './interceptor/LanguageInterceptor.interceptor';
import { ErrorInterceptor } from './interceptor/ErrorInterceptor.interceptor';
import { provideClientHydration } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { TokenInterceptor } from './interceptor/token.interceptor';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MethodsUtils } from './utils/methods.utils';
import { loadingInterceptor } from './interceptor/loader.interceptor';
import { provideServiceWorker } from '@angular/service-worker';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { offlineInterceptor } from '@interceptor/offline.interceptor';
import { DateAdapter, provideCalendar } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { provideFlatpickrDefaults } from 'angularx-flatpickr';
import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import localeEn from '@angular/common/locales/en';
import { provideNativeDateAdapter } from '@angular/material/core';
registerLocaleData(localeAr);
registerLocaleData(localeEn);
export const appConfig: ApplicationConfig = {
  providers: [
    MethodsUtils,
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideClientHydration(),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        LanguageInterceptor,
        ErrorInterceptor,
        TokenInterceptor,
        loadingInterceptor,
        offlineInterceptor,
      ]),
    ),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: translateLoaderFactory,
        },
      }),
      NgxPermissionsModule.forRoot(),
      NgxSpinnerModule.forRoot({
        type: 'ball-scale-multiple',
      }),
    ),
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: 'assets/i18n/',
        suffix: '.json',
      },
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeDirectionFactory,
      multi: true,
    },
    provideFlatpickrDefaults(),
    provideCalendar({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
};
